export default "__VITE_ASSET__Bhes52oy__"